module.exports = __webpack_public_path__ + "img/informate.e76e30fb.jpg";